"use client";

import CopyCode from "@/components/Copy/CopyCode/CopyCode";

export default function CodeBlock({ language, code, highlightedHtml }) {
    return (
        <div className="border dark:border-borderDark rounded-xl overflow-hidden mb-3 relative w-full group">
            <div className="bg-gray-50 dark:bg-bgDark-550 md:px-4 px-2.5 py-2.5 flex justify-between items-center">
                <span className="uppercase text-xs text-gray-400 font-medium">
                    {language}
                </span>
                <CopyCode code={code} />
            </div>
            <div
                dangerouslySetInnerHTML={{ __html: highlightedHtml }}
                className="[&>pre]:!m-0 [&>pre]:!rounded-none"
            />
        </div>
    );
}
